<script>
  import CalculatorForm from "../forms/CalculatorForm.svelte"
  import DonutChart from "../charts/DonutChart.svelte"

  let quantityValue = 0
  let initialPricePhase = 0
  let expectedPriceValue = 0.05
</script>

<div class="flex w-full flex-col gap-20 lg:flex-row">
  <div class="lg:w-3/5">
    <CalculatorForm bind:quantityValue bind:initialPricePhase bind:expectedPriceValue />
  </div>
  <div class="lg:w-2/5">
    <DonutChart bind:quantityValue bind:initialPricePhase bind:expectedPriceValue />
  </div>
</div>
